var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 20,
    viewBox: "0 0 1 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y2: 20,
    stroke: "#D7E2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/Line 3.9d6e483316bde0e8311891c0fb219ba2.svg";
export { ForwardRef as ReactComponent };